<template>
    <div>
        <v-container fluid :style="{ 'min-height': '800px' }">
            <v-container class="contain-width">

                <v-row>
                    <v-col
                        cols="12"
                        md="8"
                        offset-md="2"
                        lg="6"
                        offset-lg="3"
                    >
                      <h1 class="h1 mt-6 mb-6">{{ $t('headings.Cookie declaration') }}</h1>

                      <p>At <i>findmykit</i>, we are committed to safeguarding your privacy while providing you with the best possible experience on our website.</p>
                      <p>This Cookie Policy explains how we use cookies on our website. By using our website, you agree to the use of cookies in accordance with this policy. We only use cookies that are essential for the functionality of our site, ensuring a secure, seamless, and user-friendly experience. These cookies are necessary for services such as secure payment processing through Stripe and real-time customer support via the Freshchat widget.</p>

                      <h2 class="h2">What Are Cookies?</h2>
                      <p>Cookies are small text files that are stored on your device (computer, tablet, smartphone) when you visit a website. They help the website recognize your device and store information about your preferences or past actions.</p>

                      <h2 class="h2">Types of Cookies We Use</h2>
                      <p>We only use functional cookies on our website. These cookies are essential for the proper functioning of the site and cannot be disabled in our systems. Without these cookies, certain features of the website may not work as intended.</p>

                      <h2 class="h2">Functional Cookies</h2>
                      <p>These cookies are essential for the operation of the website. They allow you to navigate the site, use its features, and ensure services such as secure payment processing and real-time customer support.</p>

                      <ul>
                        <li>Enable core site functionality, such as user login, account management and checkout.</li>
                        <li>Ensure the security and integrity of our services.</li>
                      </ul>

                      <h2 class="h2">Examples of functional cookies we may use:</h2>

                      <ul>
                        <li>Session cookies to maintain your login status or progress in a form.</li>
                        <li><strong>Stripe Cookies</strong>: These cookies are necessary to enable secure online payments via Stripe. Stripe uses cookies to process payments and detect fraud or suspicious activity, ensuring a safe and secure transaction environment.</li>
                        <li><strong>Freshchat Widget Cookies</strong>: These cookies support our customer service chat functionality by allowing real-time communication with our support team. They store information about chat sessions, enabling smoother interactions and helping us assist you more effectively.</li>
                      </ul>

                      <h2>How We Use Cookies</h2>
                      <p>We use functional cookies to:</p>

                      <ul>
                        <li>Ensure that our website operates smoothly.</li>
                        <li>Provide you with services and features that you specifically request.</li>
                      </ul>

                      <h2>Cookie Consent</h2>
                      <p>Since we only use functional cookies, which are necessary for the operation of our website, we do not require explicit consent for their use. These cookies do not store any personally identifiable information and are used solely to improve your experience on our site.</p>

                      <h2>Managing Cookies</h2>
                      <p>While you cannot disable functional cookies on our site, you can manage or delete cookies at any time through your browser settings. However, please note that disabling or deleting functional cookies may impact your ability to use certain features of the site.</p>

                      <h2>Changes to This Policy</h2>
                      <p>We may update this Cookie Policy from time to time to reflect changes in our practices or for operational, legal, or regulatory reasons. Any changes will be posted on this page, so please check back periodically.</p>

                      <h2>Contact Us</h2>
                      If you have any questions or concerns about our use of cookies, please contact us at <a href="mailto:support@findmykit.com">support@findmykit.com</a>
                    </v-col>
                </v-row>
            </v-container>
        </v-container>
        <Footer />
    </div>
</template>

<script>
    import Footer from './Footer.vue'
    import { i18n } from "../i18n"
    import {mapState} from "vuex";

    export default {
        name: "Cookies",
        components: {
            'Footer': Footer
        },
        metaInfo () {
          return {
            title: this.capitalizeFirstLetter(this.brand) + ' - ' + i18n.t('headings.Cookie declaration'),
            htmlAttrs: {
              lang: i18n.locale
            },
            meta: [
              { name: 'description', content: i18n.t('This website uses cookies') + '.' + i18n.t('We use cookies to analyse our traffic') + '.' }
            ]
          }
        },
        data () {
            return {
                'status': null
            }
        },
        mounted () {

            window.scrollTo(0,0);

            this.status = this.$refs.cookie.status

            window.prerenderReady = true;

        },
        computed: {
            ...mapState({
              brand: state => state.brand,
              brandName: state => state.brandName
            }),
            getBackground() {
              if (this.brand === 'neotag') {
                return require('@/assets/neotag-background.jpg')
              }
              else {
                return require('@/assets/neotag-background.jpg')
              }
            },
            getStatus() {
                return this.status
            }
        },
        methods: {
            capitalizeFirstLetter(string) {
              return string.charAt(0).toUpperCase() + string.slice(1);
            },
            resetCookie() {
                this.$refs.cookie.removeCookie();
            },
            setStatus: function (status) {
                this.status = status
            }
        }
    }
</script>

<style scoped>

</style>
